<div class="p-6 container">
    <div class="flex flex-col sm:flex-row gap-4">
      <div class="card overflow-hidden flex-auto">
        <div class="px-6 py-4 border-b flex items-center">
          <h2 class="title m-0">Token</h2>
        </div>
        <div class="px-6 py-4 flex flex-col">
            <h2>{{ token }}&nbsp;<button
            (click)="copyToClipboard()"
            mat-icon-button
            matIconSuffix
            matTooltip="Copy to clipboard bitch!"
            type="button"
          >
                <mat-icon svgIcon="mat:file_copy"></mat-icon>
            </button></h2>
        </div> 
    </div>
</div>
</div>